import * as React from 'react';

import * as api from '@gitbook/api-client';
import { Description, Heading, Step } from '@gitbook/spine-react';

import { IntegrationInstallationStatusBadge } from './IntegrationInstallationStatusBadge';

interface StepTitleProps {
    title: string;
    headingId?: string;
    description?: string;
    content?: { title: string; icon: React.ReactElement };
    status?: api.IntegrationInstallationStatus;
}

/**
 * Wraps a step with a title and description and some default styles.
 */
export function IntegrationStepWrapper(props: { children: React.ReactNode } & StepTitleProps) {
    const { title, description, headingId, content, status } = props;
    const contentTitle = content?.title;
    const IconContent = content?.icon;

    return (
        <Step>
            <div className="flex h-full flex-col gap-6">
                <div className="flex flex-col gap-4">
                    {contentTitle ? (
                        <div className="flex items-center gap-2">
                            {IconContent &&
                                React.cloneElement(IconContent, { className: 'm-nudge-icon' })}
                            <div className="text-ui-heading-small">{contentTitle}</div>
                        </div>
                    ) : null}
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-4">
                            <Heading id={headingId} level={2} className="text-ui-heading-large">
                                {title}
                            </Heading>
                            {status ? (
                                <IntegrationInstallationStatusBadge
                                    isActive={status === api.IntegrationInstallationStatus.Active}
                                />
                            ) : null}
                        </div>

                        {description ? <Description>{description}</Description> : null}
                    </div>
                </div>

                {props.children}
            </div>
        </Step>
    );
}
